import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { FaceliftProgress } from '@/components/Atoms/FaceliftProgress';
import { useColorMode } from '@/components/ui/color-mode-utils';
import { useAuthStore } from '@/store';

const mindsightLogo = '/svgs/mindsightLogo.svg';
const mindsightLogoWhite = '/svgs/mindsightLogoWhite.svg';

const LoginLoading = ({
	text = '',
	isLoggingOut = false,
}: {
	isLoggingOut?: boolean;
	text: string;
}) => {
	const { colorMode } = useColorMode();
	const darkMode = colorMode === 'dark';
	const [progress, setProgress] = useState(0);
	const navigate = useNavigate();
	const user = useAuthStore((state) => state.user);

	useEffect(() => {
		const interval = setInterval(() => {
			setProgress((prev) => prev + 30);
		}, 30);
		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		if (progress > 100) {
			setTimeout(() => {
				if (isLoggingOut) {
					navigate('/login');
				} 
				// else {
				// 	// Only navigate if user state is ready
				// 	if (user?.userInformation) {
				// 		// navigate('/choose-platform');
				// 	}
				// }
			}, 500);
		}
	}, [progress, isLoggingOut, user]);

	return (
		<Flex
			flexDirection="column"
			gap={8}
			alignItems="center"
			mt={{ base: 0, md: 3 }}
			mb={{ base: 6, md: 3 }}
		>
			<Flex justifyContent="center">
				<Image
					objectFit="contain"
					src={darkMode ? mindsightLogoWhite : mindsightLogo}
					alt="Mindsight Logo"
					width={'240px'}
					height={'65px'}
				/>
			</Flex>
			<Flex flexDirection="column" gap={4} w="full">
				<Text
					fontSize="lg"
					color="brand.textDark"
					fontWeight="normal"
					textAlign="center"
				>
					{text}
				</Text>
				<Box w={{ base: 'full', md: '70%' }} alignSelf="center">
					<FaceliftProgress value={progress} size="md" />
				</Box>
			</Flex>
		</Flex>
	);
};

export default LoginLoading;
